var _path, _rect, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle4, _rect2, _circle5, _rect3, _circle6, _rect4, _circle7, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 131,
    viewBox: "0 0 271 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270.5 129H0V131H270.5V129Z",
    fill: "#81D4FA",
    mask: "url(#path-1-outside-1_150_8556)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 271,
    height: 130,
    fill: "#E1F5FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124 130.5H124.5V130V36C124.5 32.4101 121.59 29.5 118 29.5H23C19.4101 29.5 16.5 32.4101 16.5 36V130V130.5H17H124Z",
    fill: "#C9EBFA",
    stroke: "#81D4FA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 45,
    r: 4,
    fill: "#81D4FA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 45,
    r: 4,
    fill: "#81D4FA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 45,
    r: 4,
    fill: "#81D4FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 104C29 102.895 29.8954 102 31 102H35C36.1046 102 37 102.895 37 104V130H29V104Z",
    fill: "#81D4FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44 68C44 66.8954 44.8954 66 46 66H50C51.1046 66 52 66.8954 52 68V130H44V68Z",
    fill: "#81D4FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88C59 86.8954 59.8954 86 61 86H65C66.1046 86 67 86.8954 67 88V130H59V88Z",
    fill: "#81D4FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74 100C74 98.8954 74.8954 98 76 98H80C81.1046 98 82 98.8954 82 100V130H74V100Z",
    fill: "#81D4FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89 77C89 75.8954 89.8954 75 91 75H95C96.1046 75 97 75.8954 97 77V130H89V77Z",
    fill: "#81D4FA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104 118C104 116.895 104.895 116 106 116H110C111.105 116 112 116.895 112 118V130H104V118Z",
    fill: "#81D4FA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M254.833 130.5H255.333V130V36C255.333 32.4101 252.423 29.5 248.833 29.5H140.833C137.244 29.5 134.333 32.4101 134.333 36V130V130.5H134.833H254.833Z",
    fill: "#C9EBFA",
    stroke: "#81D4FA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 48,
    r: 6,
    fill: "#81D4FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 44,
    width: 59,
    height: 8,
    rx: 2,
    fill: "#81D4FA"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 70,
    r: 6,
    fill: "#81D4FA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 66,
    width: 25,
    height: 8,
    rx: 2,
    fill: "#81D4FA"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 92,
    r: 6,
    fill: "#81D4FA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 88,
    width: 46,
    height: 8,
    rx: 2,
    fill: "#81D4FA"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 114,
    r: 6,
    fill: "#81D4FA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 110,
    width: 51,
    height: 8,
    rx: 2,
    fill: "#81D4FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDashboard);
export default __webpack_public_path__ + "static/media/location-dashboard.10030bbc49d12de097c32074a126e88b.svg";
export { ForwardRef as ReactComponent };